import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import { LinearProgress, TextField } from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import { useForm } from "react-hook-form";
import SelectField from "../../component/SelectField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import dayjs from "dayjs";
import AccrodianBox from "../../component/AccrodianBox";
import { GoFile } from "react-icons/go";

function EditEmployee() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const [salaryStructure, setSalaryStructure] = useState([]);
  const [copySalaryStructure, setCopySalaryStructure] = useState([]);
  const [salaryCalculationReload, setSalaryCalculationReload] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedGender, setSelcetdGender] = useState("");
  const [dob, setDob] = useState(dayjs());
  const [startShieft, setStartShieft] = useState();
  const [endShieft, setEndShieft] = useState();

  // salary calculation params
  const [basic, setBasic] = useState(0);
  const [ctc, setCtc] = useState(0);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.employeeManagement === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  // userid
  const { userId } = useParams();
  const [onboardedEmployeeData, setOnboardedEmployeeData] = useState();
  const [reload, setReload] = useState(false);
  // file refs
  const qrCodeRef = useRef(null);
  const tenThRef = useRef(null);
  const twelvthRef = useRef(null);
  const gardCertRef = useRef(null);
  const postGradCertRef = useRef(null);
  const diplomaCertRef = useRef(null);
  const panCardRef = useRef(null);
  const aadharCardRef = useRef(null);
  const bankDetailsRef = useRef(null);
  const prevOffLetterRef = useRef(null);
  const prevHikeLetRef = useRef(null);
  const prevExpLetRef = useRef(null);
  const prevPayslipsRef = useRef(null);
  const prevRelivRef = useRef(null);
  const cvRef = useRef(null);
  // file hooks
  const [upiQrCode, setUpiQrCode] = useState(undefined);
  const [tenth, settenth] = useState(undefined);
  const [twelvth, settwelvth] = useState(undefined);
  const [gradCert, setgradCert] = useState(undefined);
  const [postGardCert, setpostGardCert] = useState(undefined);
  const [diplomaCert, setdiplomaCert] = useState(undefined);
  const [panCard, setpanCard] = useState(undefined);
  const [aadharCard, setaadharCard] = useState(undefined);
  const [bankDetails, setbankDetails] = useState(undefined);
  const [prevOfferLet, setprevOfferLet] = useState(undefined);
  const [prevHikeLet, setprevHikeLet] = useState(undefined);
  const [prevExpLet, setprevExpLet] = useState(undefined);
  const [prevPayslips, setprevPayslips] = useState(undefined);
  const [prevRelivLet, setprevRelivLet] = useState(undefined);
  const [cv, setcv] = useState(undefined);

  // fetch employee
  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/employee/${userId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setOnboardedEmployeeData(res.data?.data);
      // we are taking the salary structure from the employee data because there is already a salary structure with some values is stroed in employee document.
      setCopySalaryStructure(res.data?.data?.salaryStructure);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Employee data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // getSalaryStructure();
    getEmployee();
  }, [userId, reload]);

  // set values to fields
  useEffect(() => {
    setValue("fullName", onboardedEmployeeData?.fullName);
    setValue("profEmail", onboardedEmployeeData?.profEmail);
    setValue("role", onboardedEmployeeData?.role);
    setValue("designation", onboardedEmployeeData?.designation);
    setValue("phoneNumber", onboardedEmployeeData?.phoneNumber);
    setValue("probationPeriod", onboardedEmployeeData?.probationPeriod);
    setValue("department", onboardedEmployeeData?.department);
    setValue("bankName", onboardedEmployeeData?.bankName);
    setValue("bankAcNo", onboardedEmployeeData?.bankAcNo);
    setValue("panNo", onboardedEmployeeData?.panNo);
    setValue("address", onboardedEmployeeData?.address);
    setValue("city", onboardedEmployeeData?.city);
    setValue("state", onboardedEmployeeData?.state);
    setValue("country", onboardedEmployeeData?.country);
    setValue("experience", onboardedEmployeeData?.experience);
    setValue("highestEdu", onboardedEmployeeData?.highestEdu);
    setValue("gmail", onboardedEmployeeData?.gmail);
    setValue("upiId", onboardedEmployeeData?.upiId);
    setStartShieft(dayjs(onboardedEmployeeData?.startShieftTime, "HH:mm:ss"));
    setEndShieft(dayjs(onboardedEmployeeData?.endShieftTime, "HH:mm:ss"));
    setDob(dayjs(onboardedEmployeeData?.dob));
    setSelectedManager(
      `${onboardedEmployeeData?.manager}-${onboardedEmployeeData?.managerModel}`
    );
    setSelectedProject(onboardedEmployeeData?.project);
    setBasic(onboardedEmployeeData?.basic);
    setSelcetdGender(onboardedEmployeeData?.gender);
  }, [onboardedEmployeeData]);

  // onboard employee
  async function employeeDetails(data) {
    if (selectedManager?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select a manager");
      return null;
    }
    if (dob?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select the date of birth");
      return null;
    }
    if (startShieft?.$d === undefined || endShieft?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select both shieft time");
      return null;
    }
    if (basic === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter salary details");
      return null;
    }
    /* hey developer, do you remember that I merge
    two value in a string to set as "value" attribute of <option> ?
    I hope you do. Now, I am splitting the string two extract 
    two values differently from that string. */
    const splitedManagerValue = selectedManager?.split("-");
    // we need to check whether the value splitted well or not
    if (!Array.isArray(splitedManagerValue)) {
      setOpen(true);
      setSuccess(false);
      setMessage("Something went wrong");
      return null;
    }
    // structuring object for backend
    let postData = {
      ...data,
      dob: dob?.$d,
      manager: splitedManagerValue[0],
      managerModel: splitedManagerValue[1],
      startShieftTime: new Date(startShieft?.$d).toLocaleTimeString(),
      endShieftTime: new Date(endShieft?.$d).toLocaleTimeString(),
      ctc: ctc,
      project: selectedProject,
      salaryStructure: copySalaryStructure,
      id: userId,
      companyId: employeeData?.companyId,
      basic: basic,
      gender: selectedGender,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/onboarding/edit`,
        method: "post",
        data: postData,
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Employee updated successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // onboard employee
  async function employeeDocsUpdate(data) {
    const formData = new FormData();
    if (upiQrCode) formData.append("upiQrCode", upiQrCode);
    if (tenth) formData.append("tenThCert", tenth);
    if (twelvth) formData.append("twelevThCert", twelvth);
    if (gradCert) formData.append("gradCert", gradCert);
    if (postGardCert) formData.append("postGradCert", postGardCert);
    if (diplomaCert) formData.append("diplomaCert", diplomaCert);
    if (panCard) formData.append("panCard", panCard);
    if (aadharCard) formData.append("aadharCard", aadharCard);
    if (bankDetails) formData.append("bankDetails", bankDetails);
    if (prevOfferLet) formData.append("prevOfferLetter", prevOfferLet);
    if (prevHikeLet) formData.append("prevHikeLetter", prevHikeLet);
    if (prevExpLet) formData.append("prevExpLetter", prevExpLet);
    if (prevPayslips) formData.append("prevPayslips", prevPayslips);
    if (prevRelivLet) formData.append("prevRelivingLetter", prevRelivLet);
    if (cv) formData.append("cv", cv);

    formData.append("userId", userId);

    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/edit/documents`,
        method: "post",
        data: formData,
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Employee documents has been updated successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Document update failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  //fetch all projects
  async function getProjects() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/projects`,
        method: "get",
        withCredentials: true,
      });
      // save the api data
      let rawData = res.data?.data;
      // go through every element
      let selectfieldData = rawData?.map((e) => {
        // structure the data as per selectfield data structure
        let newObj = {
          title: e,
          value: e,
        };
        return newObj;
      });
      setAllProjects(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Project fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //fetch all managers
  async function getManagers() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/all/managers`,
        method: "get",
        withCredentials: true,
      });
      //console.log(res.data?.data)
      let rawData = res.data?.data;
      let selectfieldData = [];
      rawData?.map((e) => {
        let newObj = {
          title:
            e?.managerRole === "CompanySuperadmin"
              ? `${e?.name}(Superadmin)`
              : e?.name, // add a extra reference for superadmin
          value: `${e?.mangerId}-${e?.managerRole}`, // we can't set object as "value" attribute of <option> tag but we can set string. I combine two data in a string.
        };
        selectfieldData.push(newObj);
      });
      setManagers(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Managers fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // gender array
  const genderArray = [
    {
      title: "Male",
      value: "Male",
    },
    {
      title: "Female",
      value: "Female",
    },
    {
      title: "Others",
      value: "Others",
    },
  ];

  useEffect(() => {
    getProjects();
    getManagers();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center flex-col">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full text-slate-700">
            Update Employee
          </h1>
          <div className="mt-5 w-full">
            <AccrodianBox title={"Employee Details"}>
              <form className="mt-5" onSubmit={handleSubmit(employeeDetails)}>
                <div className="w-full">
                  <p className="mb-5 font-medium text-[17px]">
                    Personal & Job Details
                  </p>
                  <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                    <InputField
                      label="Name"
                      {...register("fullName", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.name}
                    />
                    <TextField
                      label="Professional Email"
                      type="email"
                      {...register("profEmail", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.email}
                    />
                    <TextField
                      label="Personal Email"
                      type="email"
                      {...register("gmail", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.email}
                    />
                    <InputField
                      label="Role"
                      {...register("role", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.role}
                    />
                    <InputField
                      label="Designation"
                      {...register("designation", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.designation}
                    />
                    <InputField
                      label="Phone Number"
                      {...register("phoneNumber", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        minLength: {
                          value: 10,
                          message:
                            "Phone number should not be less than 10 digits",
                        },
                        maxLength: {
                          value: 10,
                          message:
                            "Phone number should not be greater than 10 digits",
                        },
                        setValueAs: (value) => value.trim(),
                      })}
                      focused
                      error={errors?.phoneNumber}
                    />
                    <InputField
                      label="Probation Period(in months)"
                      {...register("probationPeriod", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.probationPeriod}
                    />
                    <SelectField
                      label="Manager"
                      value={selectedManager}
                      setValue={(e) => setSelectedManager(e?.target?.value)}
                      valueArray={managers}
                    />
                    {/* <SelectField
                      label="Project"
                      value={selectedProject}
                      setValue={(e) => setSelectedProject(e?.target?.value)}
                      valueArray={allProjects}
                    /> */}
                    <SelectField
                      label="Gender"
                      value={selectedGender}
                      setValue={(e) => setSelcetdGender(e?.target?.value)}
                      valueArray={genderArray}
                    />
                    <InputField
                      label="Department"
                      {...register("department", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.department}
                    />
                    <InputField
                      label="Bank Name"
                      {...register("bankName", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.bankName}
                    />
                    <InputField
                      label="Bank A/C No"
                      {...register("bankAcNo", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.bankAcNo}
                    />
                    <InputField
                      label="UPI ID"
                      {...register("upiId", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.upiId}
                    />
                    <InputField
                      label="PAN No"
                      {...register("panNo", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.panNo}
                    />
                    <InputField
                      label="Address"
                      {...register("address", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.address}
                    />
                    <InputField
                      label="City"
                      {...register("city", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.city}
                    />
                    <InputField
                      label="State"
                      {...register("state", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.state}
                    />
                    <InputField
                      label="Country"
                      {...register("country", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.country}
                    />
                    <InputField
                      label="Experience"
                      {...register("experience", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.experience}
                    />
                    <InputField
                      label="Highest Education"
                      {...register("highestEdu", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      focused
                      error={errors?.highestEdu}
                    />
                    <DatePicker
                      label="Date of birth"
                      onChange={(e) => setDob(e)}
                      value={dob}
                    />
                  </div>
                </div>
                <div className="mt-5">
                  {
                    <DemoContainer
                      components={["MobileTimePicker", "MobileTimePicker"]}
                    >
                      <div className="w-full">
                        <p className="text-[17px] font-medium">Shieft</p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10 mt-5">
                          <MobileTimePicker
                            label="From"
                            className="w-full"
                            onChange={setStartShieft}
                            value={startShieft}
                          />
                          <MobileTimePicker
                            label="To"
                            className="w-full"
                            onChange={setEndShieft}
                            value={endShieft}
                          />
                        </div>
                      </div>
                    </DemoContainer>
                  }
                </div>
                <div className="mt-5 w-full flex justify-end items-end">
                  <ButtonCompo variant={"contained"} type="submit">
                    Save
                  </ButtonCompo>
                </div>
              </form>
            </AccrodianBox>
            <AccrodianBox title={"Employee Documents"}>
              <div className="">
                <div>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={tenThRef}
                          onChange={(e) => settenth(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            10th Certificate
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {tenth !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.tenThCert !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.tenThCert}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => tenThRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={twelvthRef}
                          onChange={(e) => settwelvth(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            12th Certificate
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {twelvth !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.twelevThCert !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.twelevThCert}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => twelvthRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={gardCertRef}
                          onChange={(e) => setgradCert(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Graduation Certificate
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {gradCert !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.gradCert !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.gradCert}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => gardCertRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={postGradCertRef}
                          onChange={(e) => setpostGardCert(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Post Graduation Certificate
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {postGardCert !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.postGradCert !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.postGradCert}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => postGradCertRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={diplomaCertRef}
                          onChange={(e) => setdiplomaCert(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Diploma Certificate
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {diplomaCert !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.diplomaCert !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.diplomaCert}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => diplomaCertRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={panCardRef}
                          onChange={(e) => setpanCard(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            PAN Card
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {panCard !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.panCard !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.panCard}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => panCardRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={aadharCardRef}
                          onChange={(e) => setaadharCard(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            AADHAR Card
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {aadharCard !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.aadharCard !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.aadharCard}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => aadharCardRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={bankDetailsRef}
                          onChange={(e) => setbankDetails(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Bank Details
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {bankDetails !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.bankDetails !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.bankDetails}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => bankDetailsRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={qrCodeRef}
                          onChange={(e) => setUpiQrCode(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            UPI QR Code
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {upiQrCode !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.upiQrCode !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.upiQrCode}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => qrCodeRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={prevOffLetterRef}
                          onChange={(e) => setprevOfferLet(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Previous Offer Letter
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {prevOfferLet !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.prevOfferLetter !==
                        undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.prevOfferLetter}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => prevOffLetterRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={prevHikeLetRef}
                          onChange={(e) => setprevHikeLet(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Previous Hike Letter
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {prevHikeLet !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.prevHikeLetter !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.prevHikeLetter}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => prevHikeLetRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={prevExpLetRef}
                          onChange={(e) => setprevExpLet(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Previous Experience Letter
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {prevExpLet !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.prevExpLetter !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.prevExpLetter}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => prevExpLetRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={prevPayslipsRef}
                          onChange={(e) => setprevPayslips(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Previous Payslips
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {prevPayslips !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.prevPayslips !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.prevPayslips}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => prevPayslipsRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={prevRelivRef}
                          onChange={(e) => setprevRelivLet(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            Previous Reliving Letter
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {prevRelivLet !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.prevRelivingLetter !==
                        undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.prevRelivingLetter}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => prevRelivRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                  <section>
                    <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
                      <div className="flex gap-3 items-center">
                        <input
                          type="file"
                          className="hidden"
                          ref={cvRef}
                          onChange={(e) => setcv(e?.target?.files[0])}
                        />
                        <span className="bg-slate-200/50 p-2 rounded-full">
                          <GoFile className="text-[20px] text-slate-800" />
                        </span>
                        <div>
                          <p className="text-[15px] font-medium text-slate-700">
                            CV
                          </p>
                        </div>
                        <p className="text-blue-600 text-[13px] font-medium">
                          {cv !== undefined ? "1 file selected" : ""}
                        </p>
                      </div>
                      <section className="flex items-center gap-5">
                        {onboardedEmployeeData?.cv !== undefined ? (
                          <Link
                            to={`${SERVER_URL}/api/v1/file/view/${onboardedEmployeeData?.cv}`}
                            target="_blank"
                          >
                            <ButtonCompo>Download</ButtonCompo>
                          </Link>
                        ) : (
                          <ButtonCompo disabled>Download</ButtonCompo>
                        )}
                        <ButtonCompo
                          variant={"contained"}
                          onClick={() => cvRef.current.click()}
                        >
                          Update
                        </ButtonCompo>
                      </section>
                    </div>
                  </section>
                </div>
                <div className="mt-10 flex justify-end">
                  <ButtonCompo
                    variant={"contained"}
                    onClick={employeeDocsUpdate}
                  >
                    Save Changes
                  </ButtonCompo>
                </div>
              </div>
            </AccrodianBox>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditEmployee;
